"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceText = void 0;
var PriceText;
exports.PriceText = PriceText;

(function (PriceText) {
  PriceText["REGULAR"] = "regular";
  PriceText["SALE"] = "sale";
  PriceText["DIAMOND_MEMBER"] = "diamond member";
  PriceText["DIAMOND_SIGNUP_TEXT"] = "Join for Free";
  PriceText["DIAMOND_SIGNUP_LINK"] = "/loyalty";
})(PriceText || (exports.PriceText = PriceText = {}));